<template>
    <div>
        <h1 class="text-lg font-bold">{{displayName | capitalizeFirstLetter}} introuvable</h1>

        <div class="mt-2">{{ $t('form.appareil.nous_sommes_navres') }}</div>

        <sav-input
        type="text"
        class="my-3"
        :placeholder="$t('form.appareil.nom_du_modele')"
        rows="5"
        v-model="requestComment"
        />

        <button :disabled="loadingRequest" @click="sendRequestForm()" class="p-2 px-4 text-sm font-light text-white duration-200 bg-green-500 hover:bg-green-600 rounded-xl">
            <i class="fa-solid fa-check mr-0.5"></i> {{ $tt('Envoyer') }}
        </button>
        <button :disabled="loadingRequest" @click="$emit('close')" class="p-2 px-4 text-sm font-light duration-200 bg-gray-300 hover:bg-gray-400 rounded-xl">
            <i class="fa-solid fa-times mr-0.5"></i> {{ $tt('Annuler') }}
        </button>
    </div>
</template>

<script>
import apiService from '@/services/api.service'

export default {
    props: {
        displayName: {
            type: String,
            required: true
        },
        libelle: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            requestComment: null,
            loadingRequest: false
        }
    },

    computed: {
        uniqueId() {
            let id = this.displayName.replace(' ', '-')
            return 'modal-request-' + id + '-' + Date.now()
        }
    },

    filters: {
        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    },

    methods: {
        async sendRequestForm() {
            this.loadingRequest = true
            let response = await apiService.post('no_ref', {
                comment: this.requestComment,
                libelle: this.libelle
            })
            if (response.data && response.data.posts.post == '1') {
                this.$modal.hide(this.uniqueId)
                this.$toast.success('Nous faisons le nécessaire pour mettre à jour nos informations')
                localStorage.removeItem('form-data')
                this.$router.push({name: 'home'})
            }
            this.$emit('close')
            this.loadingRequest = false
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/SavRequestModal.vue